
// import Breadcrumb from "@/components/Breadcrumb";
// const ListLoading = () => import("@/components/ListLoading");
import { mapGetters } from 'vuex'
import { parseTime } from '~/utils/validate.js'

export default {
    name: 'moreDeals',
    components: {
        // Breadcrumb,
        // ListLoading,
    },
    computed: {
        ...mapGetters({ goodsTypeCateList: 'game/goodsTypeCateList' })
    },
    data() {
        return {
            loading: false,
            everyDayTransactionList: [],
            maxTime: null,
            minTime: null
        }
    },
    methods: {
        goMore(e) {
            console.log('eeeeeeeeeeeeeeeee', e)

            this.$router.push({
                path: '/more',
                query: {
                    gameId: this.$route.query.gameId,
                    goodsCatalogueId: this.$route.query.goodsCatalogueId,
                    isTop: e.isTop,
                    time: e.fmtDate
                }
            })
        },
        dayTransaction() {
            const info = {
                action: {
                    goodsCatalogueId: this.$route.query.goodsCatalogueId,
                    gameId: this.$route.query.gameId,
                    minTransactionTime: `${parseTime(new Date() - 480 * 60 * 60 * 1000, '{y}-{m}-{d}')} 00:00:00`,
                    maxTransactionTime: `${parseTime(new Date() - 24 * 60 * 60 * 1000, '{y}-{m}-{d}')} 23:59:59`
                }
                // action: {
                // 	goodsCatalogueId: this.goodsCatalogueId,
                // 	gameId: this.gameId,
                // 	minTransactionTime: '2022-10-08 00:00:00',
                // 	maxTransactionTime: '2022-10-18 00:00:00',
                // },
            }
            this.$api.dayTransaction(info).then((res) => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.everyDayTransactionList = res.data
                this.everyDayTransactionList.map((item) => {
                    return (item.goodsImg = item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg'))
                })
            })
        }
    },

    created() {
        this.maxTime = parseTime(new Date() - 24 * 60 * 60 * 1000, '{y}-{m}-{d}')
        this.minTime = parseTime(new Date() - 480 * 60 * 60 * 1000, '{y}-{m}-{d}')
        this.dayTransaction()
        this.$store.dispatch('game/GoodsTypeCateList')
    }
}
